import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi from "i18next-http-backend";
import { withBackendUrl } from "../helper/common";
import pendingEnUs from "../locales/pending/en-us.json";
import pendingEs from "../locales/pending/es.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .use(HttpApi)
  .init({
    debug: true,
    returnNull: false,
    lng: localStorage.getItem("i18nextLng") ?? "es",
    fallbackLng: "en-us",
    load: "currentOnly",
    lowerCaseLng: true,
    ns: ["translation", "fixed"], // Specify the namespaces you are using
    defaultNS: "translation",
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: withBackendUrl("/locales/{{lng}}/{{ns}}"),
      addPath: withBackendUrl("/locales/add/{{lng}}/{{ns}}"),
      crossDomain: true,
      reloadInterval: false,
      allowMultiLoading: true,
      parse: (data, url) => {
        let langData = JSON.parse(data);
        if (Object.keys(langData).length > 0) {
          let firstKey = Object.keys(langData)[0];
          langData = langData[firstKey];
          if (Object.keys(langData).length > 0) {
            let secKey = Object.keys(langData)[0];
            langData = langData[secKey];
          }
        }
        return langData;
      },
    },
    partialBundledLanguages: true,
    saveMissing: true,
  });

// Text for new keys that are not on the server yet (see src/locales/pending).
// The server wins, unless its value is missing, empty or just the key name.
const PENDING_TRANSLATIONS = { "en-us": pendingEnUs, es: pendingEs };

const addPendingTranslations = (lng) => {
  const pending = PENDING_TRANSLATIONS[lng];
  if (!pending) return;
  Object.entries(pending).forEach(([key, text]) => {
    const fromServer = i18n.getResource(lng, "translation", key);
    if (!fromServer || fromServer === key) {
      i18n.addResource(lng, "translation", key, text, { silent: true });
    }
  });
};

i18n.on("loaded", (loaded) => {
  Object.keys(loaded).forEach(addPendingTranslations);
});
i18n.on("failedLoading", (lng) => addPendingTranslations(lng));

export default i18n;
